import { ACL_PRIVATE } from '../../../../s3';

define((require, exports, module) => {
    'use strict';

    const s3fs = require('./s3fs');
    const uid = require('../uid');
    const uploadRadar = require('../../uploadRadar');
    const UploadDescriptor = require('../../UploadDescriptor');
    const fileSystemPath = require('../fs/fileSystemPath');

    /**
     * @param {number} name – string
     * @returns {Promise}
     * @resolves
     * @rejects
     */
    function createFolder(name) {
        const descriptor = new UploadDescriptor({
            id: uid(),
            isDirectory: true,
            radar: uploadRadar.create(),
            remotePath: fileSystemPath.join(
                s3fs.getWorkingDirectory(),
                name,
                '/',
            ),

            // Публиковать папки смысла нет, потому что это пустые файлы,
            // созданные с целью получить CommonPrefix в s3.listObjects(…)
            ACL: ACL_PRIVATE,
        });

        return descriptor.upload();
    }

    module.exports = createFolder;
});
